import z from "zod";

/**
 * FornecedorDocumentoSchema
 */

export const FornecedorDocumentoSchema = z.object({
  status: z.coerce.number().default(1),
  nomeDocumento: z.string().nonempty('Este campo deve ser preenchido!'),
  dataVencimento: z.coerce.date().nullable().default(null),
  file: z.instanceof(File).nullable().default(null),
  limparArquivo: z.boolean(),
  possuiArquivo: z.boolean(),
}).superRefine((data, ctx) => {
  if (data.possuiArquivo === false) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['file'],
    });
  }
});

/**
 * FornecedorDocumentoForm
 */

export type FornecedorDocumentoForm = z.infer<typeof FornecedorDocumentoSchema>;